import accordionStyle from "@nectary/theme-base/comp/accordion.css";
import actionMenuStyle from "@nectary/theme-base/comp/action-menu.css";
import alertStyle from "@nectary/theme-base/comp/alert.css";
import avatarStyle from "@nectary/theme-base/comp/avatar.css";
import badgeStyle from "@nectary/theme-base/comp/badge.css";
import buttonStyle from "@nectary/theme-base/comp/button.css";
import cardStyle from "@nectary/theme-base/comp/card.css";
import chatStyle from "@nectary/theme-base/comp/chat.css";
import checkboxStyle from "@nectary/theme-base/comp/checkbox.css";
import chipStyle from "@nectary/theme-base/comp/chip.css";
import codeSnippetStyle from "@nectary/theme-base/comp/code-snippet.css";
import codeTagStyle from "@nectary/theme-base/comp/code-tag.css";
import colorSwatchStyle from "@nectary/theme-base/comp/color-swatch.css";
import datePickerStyle from "@nectary/theme-base/comp/date-picker.css";
import dialogStyle from "@nectary/theme-base/comp/dialog.css";
import emojiPickerStyle from "@nectary/theme-base/comp/emoji-picker.css";
import emojiStyle from "@nectary/theme-base/comp/emoji.css";
import fieldStyle from "@nectary/theme-base/comp/field.css";
import fileDropStyle from "@nectary/theme-base/comp/file-drop.css";
import fileStatusStyle from "@nectary/theme-base/comp/file-status.css";
import flagStyle from "@nectary/theme-base/comp/flag.css";
import iconButtonStyle from "@nectary/theme-base/comp/icon-button.css";
import iconStyle from "@nectary/theme-base/comp/icon.css";
import inlineAlertStyle from "@nectary/theme-base/comp/inline-alert.css";
import inputStyle from "@nectary/theme-base/comp/input.css";
import linkStyle from "@nectary/theme-base/comp/link.css";
import listStyle from "@nectary/theme-base/comp/list.css";
import paginationStyle from "@nectary/theme-base/comp/pagination.css";
import popoverStyle from "@nectary/theme-base/comp/popover.css";
import progressStyle from "@nectary/theme-base/comp/progress.css";
import radioStyle from "@nectary/theme-base/comp/radio.css";
import segmentStyle from "@nectary/theme-base/comp/segment.css";
import segmentedControlStyle from "@nectary/theme-base/comp/segmented-control.css";
import selectButtonStyle from "@nectary/theme-base/comp/select-button.css";
import selectMenuStyle from "@nectary/theme-base/comp/select-menu.css";
import tabStyle from "@nectary/theme-base/comp/tab.css";
import tableStyle from "@nectary/theme-base/comp/table.css";
import tagStyle from "@nectary/theme-base/comp/tag.css";
import textAreaStyle from "@nectary/theme-base/comp/textarea.css";
import tileControlStyle from "@nectary/theme-base/comp/tile-control.css";
import timePickerStyle from "@nectary/theme-base/comp/time-picker.css";
import toastStyle from "@nectary/theme-base/comp/toast.css";
import toggleStyle from "@nectary/theme-base/comp/toggle.css";
import tooltipStyle from "@nectary/theme-base/comp/tooltip.css";
import fontsStyle from "@nectary/theme-base/fonts.css";
import indexStyle from "@nectary/theme-base/index.css";
import refStyle from "@nectary/theme-base/ref.css";
import system from "@nectary/theme-base/sys.css";
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  ${accordionStyle}
  ${actionMenuStyle}
  ${alertStyle}
  ${avatarStyle}
  ${badgeStyle}
  ${buttonStyle}
  ${cardStyle}
  ${chatStyle}
  ${checkboxStyle}
  ${chipStyle}
  ${codeSnippetStyle}
  ${codeTagStyle}
  ${colorSwatchStyle}
  ${datePickerStyle}
  ${dialogStyle}
  ${emojiPickerStyle}
  ${emojiStyle}
  ${fieldStyle}
  ${fileDropStyle}
  ${fileStatusStyle}
  ${flagStyle}
  ${fontsStyle}
  ${iconButtonStyle}
  ${iconStyle}
  ${indexStyle}
  ${inputStyle}
  ${inlineAlertStyle}
  ${linkStyle}
  ${listStyle}
  ${paginationStyle}
  ${popoverStyle}
  ${progressStyle}
  ${radioStyle}
  ${segmentStyle}
  ${segmentedControlStyle}
  ${selectButtonStyle}
  ${selectMenuStyle}
  ${tabStyle}
  ${tableStyle}
  ${tagStyle}
  ${textAreaStyle}
  ${tileControlStyle}
  ${timePickerStyle}
  ${toastStyle}
  ${toggleStyle}
  ${tooltipStyle}
  ${system}
  ${refStyle}
  ${/*fontsStyle - has no effect in shadow roots*/ ""}
`;
